import { render, staticRenderFns } from "./ProductStores.vue?vue&type=template&id=50058b7f&scoped=true&"
import script from "./ProductStores.vue?vue&type=script&lang=js&"
export * from "./ProductStores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50058b7f",
  null
  
)

export default component.exports